define("calendar/components/calendar/drop-zone", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cDZ--dropzoneWrapper--auto">
    <div class="cDZ--dropzone" {{droppable onDrop=@onDrop onDragEnter=@onDragEnter onDragLeave=@onDragLeave}}>
      {{#if @showReleaseText}}
        {{! Message: Display when media items have been dragged over the drop zone }}
        <span class="cDZ--dropzone__text">
          {{t "calendar.drop_zone.release_text"}}
        </span>
      {{else}}
        <span class="cDZ--dropzone__text">
          {{@text}}
        </span>
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "FblVBT8N",
    "block": "[[[10,0],[14,0,\"cDZ--dropzoneWrapper--auto\"],[12],[1,\"\\n  \"],[11,0],[24,0,\"cDZ--dropzone\"],[4,[38,0],null,[[\"onDrop\",\"onDragEnter\",\"onDragLeave\"],[[30,1],[30,2],[30,3]]]],[12],[1,\"\\n\"],[41,[30,4],[[[1,\"      \"],[10,1],[14,0,\"cDZ--dropzone__text\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"calendar.drop_zone.release_text\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[14,0,\"cDZ--dropzone__text\"],[12],[1,\"\\n        \"],[1,[30,5]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@onDrop\",\"@onDragEnter\",\"@onDragLeave\",\"@showReleaseText\",\"@text\"],false,[\"droppable\",\"if\",\"t\"]]",
    "moduleName": "calendar/components/calendar/drop-zone.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});